import { GET_LANDING_PAGE_COMPLETE, GET_LANDING_PAGE_ERROR } from '../actions/actionTypes';
import initialState from './initialState';

export default function update(state = initialState.landingPage, action) {
  if (action.type === GET_LANDING_PAGE_COMPLETE || action.type === GET_LANDING_PAGE_ERROR) {
    return action.payload.landingPage;
  } else {
    return state;
  }
}
